import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/positive-icon.svg'
import _imports_1 from '../../assets/negative-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-6a85a66e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary-back back-button",
  onclick: "window.history.back();"
}, " Back ", -1))
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "strength-header" }
const _hoisted_6 = { class: "image-container" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "header-text" }
const _hoisted_9 = {
  class: "strength-title",
  "data-test": "sp-name"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr-magazine hr-magazine-left hr-magazine-thick hr-magazine-short" }, null, -1))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "section splitter" }, null, -1))
const _hoisted_13 = { role: "main" }
const _hoisted_14 = {
  class: "text-content",
  "data-test": "sp-long-description"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "section splitter" }, null, -1))
const _hoisted_16 = { class: "button-container" }
const _hoisted_17 = { class: "indicator-grid" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell grid-header left-column pos-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "positive"
  }),
  /*#__PURE__*/_createElementVNode("h2", null, "Positive Indicators")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell grid-header neg-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "positive"
  }),
  /*#__PURE__*/_createElementVNode("h2", null, "Negative Indicators")
], -1))
const _hoisted_20 = { class: "grid-cell left-column grid-list pos-desc" }
const _hoisted_21 = { "data-test": "sp-positives" }
const _hoisted_22 = { class: "grid-cell grid-list neg-desc" }
const _hoisted_23 = { "data-test": "sp-negatives" }

import { onBeforeMount, ref, watchEffect } from "vue";
import { useRoute } from "vue-router";
import cms from "../../services/cms/cms";
import { CmsDocumentTypes } from "../../services/cms/cms-type-configuration";
import { CmsStrengthItemData } from "../../services/cms/cms-type-definitions";
import StrengthPageModal from "../../components/cms/strength-page-modal.vue";
import { csContext } from "../../services/cs-context";
import {
  DevelopStrengthProgressApiModel,
  LockStatusApiModel,
  ProfileApiModel,
  UserDetailsApiSubscriptionLevel,
} from "../../api-models";
import { useAxios } from "../../composables/api";
import LoadingPage from "../loading-page.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'strength-page',
  setup(__props) {

const currentDevelopPlan = ref<DevelopStrengthProgressApiModel | undefined>(undefined);
const otherProgress = ref<DevelopStrengthProgressApiModel[] | undefined>(undefined);
const strengthData = ref<CmsStrengthItemData | null>(null);
const isSoloCompleted = ref<LockStatusApiModel | undefined>(
  csContext.userProfile.soloReportLockStatus,
);
const subscriptionLevel = ref<UserDetailsApiSubscriptionLevel | undefined>(
  csContext.user.subscriptionLevel,
);
const strengthPageModal = ref<InstanceType<typeof StrengthPageModal> | null>(null);
const strengthName = ref(useRoute().params.strength);

const isLoading = ref(true);

const openModal = (): void => {
  strengthPageModal.value?.openModal();
};

const getCmsData = async (): Promise<void> => {
  const response = await cms.getByUid(CmsDocumentTypes.CmsStrengthItem, `${strengthName.value}`);
  strengthData.value = response.data;
};

const { promise } = useAxios<ProfileApiModel>("/api/profile");
promise.then((profile) => {
  currentDevelopPlan.value = profile.developProgress?.currentStrengthProgress;
  otherProgress.value = profile.developProgress?.otherProgress;
});

watchEffect(() => {
  if (strengthData.value) {
    isLoading.value = false;
  }
});

onBeforeMount(async () => {
  await getCmsData();
});

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(StrengthPageModal, {
            ref_key: "strengthPageModal",
            ref: strengthPageModal,
            strengthData: strengthData.value,
            currentDevelopPlan: currentDevelopPlan.value,
            isSoloCompleted: isSoloCompleted.value,
            subscriptionLevel: subscriptionLevel.value,
            otherProgress: otherProgress.value
          }, null, 8, ["strengthData", "currentDevelopPlan", "isSoloCompleted", "subscriptionLevel", "otherProgress"]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("header", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "strength-image",
                  src: strengthData.value.strength_image.url,
                  alt: `${strengthData.value.name} icon`,
                  "data-test": "sp-image"
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h1", _hoisted_9, _toDisplayString(strengthData.value.name), 1),
                _hoisted_10,
                _createElementVNode("div", {
                  class: "short-definition",
                  innerHTML: _unref(cms).asHtml(strengthData.value.short_definition),
                  "data-test": "sp-short-def"
                }, null, 8, _hoisted_11)
              ])
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("section", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(strengthData.value.long_description, (description, index) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: index,
                    class: "description"
                  }, _toDisplayString(description.text), 1))
                }), 128))
              ]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                (currentDevelopPlan.value === strengthData.value.name)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-primary develop-button",
                      onClick: openModal,
                      "data-test": "sp-continue-button",
                      type: "button"
                    }, " Continue "))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-primary develop-button",
                      onClick: openModal,
                      "data-test": "sp-develop-button",
                      type: "button"
                    }, " Develop "))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("ul", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(strengthData.value.positive_indicators, (posIndicator, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(posIndicator.description[0].text), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("ul", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(strengthData.value.negative_indicators, (negIndicator, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(negIndicator.description[0].text), 1))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
}
}

})